import axios from 'axios';
import { defineStore } from 'pinia';
import { intersection } from 'lodash';

interface UserAuthenticationData
{
  id: string
  name: string
  roles: number[]
}

interface State
{
  user: UserAuthenticationData | null
}

export const useAuthenticationStore = defineStore('authentication', {
  state: (): State =>
  {
    return {
      user: null,
    };
  },
  actions: {
    async me(): Promise<boolean>
    {
      try
      {
        const { data: user } = await axios.get<UserAuthenticationData>('me');
        this.user = user;
        return true;
      }
      catch
      {
        return false;
      }
    },

    async login(globalSessionId: string): Promise<boolean>
    {
      try
      {
        const { data: user } = await axios.post<UserAuthenticationData>('login', { globalSessionId });
        this.user = user;
        return true;
      }
      catch
      {
        return false;
      }
    },

    async logout(): Promise<void>
    {
      try
      {
        await axios.post('logout');
      }
      finally
      {
        this.user = null;
      }
    },

    hasRoles(roles: number[]): boolean
    {
      if (!this.user)
      {
        return false;
      }

      if (roles.length === 0)
      {
        return true;
      }

      return intersection(this.user?.roles ?? [], roles).length > 0;
    },

    set(user: UserAuthenticationData): void
    {
      this.user = user;
    },
  },
});
